import { IGNORED_LAST_BREADCRUMB_ROUTES } from '@/constants/breadcrumb';

export const shouldIgnoreLastBreadcrumb = (pathname: string): boolean => {
  return IGNORED_LAST_BREADCRUMB_ROUTES.some((route) =>
    pathname.startsWith(route)
  );
};
